import { eventPropTypes } from "../../../../global/propTypes";
import EventDetails from "../EventDetails";
import OnlineInvitationEventGuest from "./OnlineInvitationEventGuest";
import OnlineInvitationSignup from "./OnlineInvitationSignup";
import { css } from "@emotion/react";
import { styleUtils, theme } from "@minted/minted-components";
import { shape, string, number, bool } from "prop-types";
import React from "react";

const eventsGuestsSummaryStyles = {
  card: css`
    background-color:
    border: ${styleUtils.rem(1)} solid ${theme.colors.gray300};
    border-radius: ${theme.spacing.base};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.x6};
    padding: ${theme.spacing.x4};
    padding-bottom: ${theme.spacing.x4};
  `,
  eventGuestWrapper: css`
    background-color: ${theme.colors.gray200};
    display: grid;
    gap: ${theme.spacing.x5};
    padding: ${theme.spacing.x4};
    ${theme.media.lessThan("medium")`
      padding: ${theme.spacing.x5};
    `};
  `,
  headerWrapper: css`
    margin-left: ${theme.spacing.x5};
    margin-right: ${theme.spacing.x5};
    padding-bottom: ${theme.spacing.x4};
    padding-top: ${theme.spacing.x4};
    text-align: center;
    ${theme.media.lessThan("medium")`
      margin-left: ${theme.spacing.x4};
      margin-right: ${theme.spacing.x4};
    `};
  `,
  subHeadingText: css`
    ${theme.typeStyles.bodySmallStyles};

    margin-bottom: ${theme.spacing.x3};
  `,
};

const OnlineInvitationEventsGuestsSummary = ({
  contactData,
  event,
  guest,
  guestResponse,
  isMobile,
  noteToHost,
  partySize,
  siteId,
}) => {
  return (
    <div data-cy="eventsGuestsSummary">
      <OnlineInvitationSignup siteId={siteId} />
      <div key={`eventWrapper${event.id}`}>
        <EventDetails
          calendarUrls={event.calendarUrls}
          event={event}
          index={0}
          isMobile={isMobile}
          readOnly
          totalEvents={1}
        />
      </div>
      <div css={eventsGuestsSummaryStyles.headerWrapper}>
        <div css={eventsGuestsSummaryStyles.subHeadingText}>
          Thank you for responding!
        </div>
      </div>
      <div css={eventsGuestsSummaryStyles.eventGuestWrapper}>
        <OnlineInvitationEventGuest
          contactData={contactData}
          guest={guest}
          guestResponse={guestResponse}
          noteToHost={noteToHost}
          partySize={partySize}
          questions={event.questions}
          readOnly
        />
      </div>
    </div>
  );
};

OnlineInvitationEventsGuestsSummary.propTypes = {
  contactData: shape({
    email: string,
    id: string,
    name: string,
  }).isRequired,
  event: eventPropTypes.isRequired,
  guest: shape({
    firstName: string,
    id: number.isRequired,
    lastName: string,
  }).isRequired,
  guestResponse: shape({}).isRequired,
  isMobile: bool.isRequired,
  noteToHost: string,
};

export default OnlineInvitationEventsGuestsSummary;
